export default __webpack_public_path__ + "75ce6d8e7fca24c454a9b8116b1a3509.png";